<script setup lang="ts">
import { useDetectMobile } from '@/application/composables/detectMobile.ts';
import { DsIcon } from '@demvsystems/design-components';
import { ElButton, ElDrawer, ElDialog } from 'element-plus';

interface Props {
  show: boolean;
  title: string;
  height: string
}

defineProps<Props>();
defineEmits(['close', 'closed']);

const { isMobile } = useDetectMobile();

</script>

<template>
  <ElDrawer
    v-if="isMobile"
    :model-value="show"
    direction="btt"
    :show-close="false"
    class="rounded-t-2xl"
    modal-class="pb-safe"
    header-class="mb-0 pb-1"
    modal
    :title="title"
    :size="height"
    @close="show && $emit('close')"
    @closed="$emit('closed')"
  >
    <template #header>
      <div class="flex flex-row items-center justify-between">
        <span class="text-xl text-gray-900">{{ title }}</span>
        <ElButton text circle bg aria-label="Schließen" @click="$emit('close')">
          <DsIcon name="times" size="lg" />
        </ElButton>
      </div>
    </template>
    <slot />
  </ElDrawer>

  <ElDialog
    v-else
    :model-value="show"
    :width="512"
    :show-close="false"
    :title="title"
    align-center
    @close="show && $emit('close')"
    @closed="$emit('closed')"
  >
    <template #header>
      <div class="flex flex-row items-center justify-between">
        <span class="text-xl text-gray-900">{{ title }}</span>
        <ElButton text circle aria-label="Schließen" bg @click="$emit('close')">
          <DsIcon name="times" size="lg" />
        </ElButton>
      </div>
    </template>
    <slot />
  </ElDialog>
</template>
